import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisCoreSharedModule } from '../../../../../../core/his-core-shared.module';
import { HisUiService } from '../../../../../../core/service/base/his-ui.service';
import { HisNotificationService } from '../../../../../../core/service/notifications/his-notification.service';

@Component( {
    standalone: true,
    selector: 'his-bi-copy-open-link',
    templateUrl: './copy-open-link.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HisCoreSharedModule]
} )
export class CopyOpenLinkComponent {
    private notificationService = inject( HisNotificationService );
    private hisUi = inject( HisUiService );


    @Input( { required: true } ) permalink!: string;

    copyLinkToClipboard( permalink: string ) {
        navigator.clipboard.writeText( permalink )
            .then( () => this.notificationService.success(
                this.hisUi.translate( 'common.copyToClipboard.success', this.hisUi.translate(
                    'cs.sys.portal.editportlet.deepLinkSettings' ) ),
                this.hisUi.translate( 'fs.res.common.success' )
            ) );
    }
}
